var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.11 36.85a14.17 14.17 0 0 0-10-10c-8.79-2.37-44-2.37-44-2.37s-35.26 0-44.05 2.37a14.17 14.17 0 0 0-10 10c-2.35 8.84-2.35 27.31-2.35 27.31s0 18.46 2.36 27.3a14.15 14.15 0 0 0 10 10c8.79 2.38 44.05 2.38 44.05 2.38s35.26 0 44.05-2.38a14.15 14.15 0 0 0 10-10c2.35-8.84 2.35-27.3 2.35-27.3s-.06-18.47-2.41-27.31Z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m52.56 80.92 29.47-16.76L52.56 47.4v33.52z"
  })));
};
export default SvgYoutube;